type MortgageLabel = { name: string; section: string };

export const createTrackingLabel = (data: MortgageLabel): string => {
    return `${data.name} - ${data.section}`;
};
